import { FC } from 'react';
import classNames from 'classnames';
import seoBlockContentCss from './assets/seo-block-content.module.scss';
import { useSeoBlockContext } from './hooks';
import { SeoBlockLinkList } from './link-list/SeoBlockLinkList';
import { SeoBlockCityList } from './city-list/SeoBlockCityList';
import { SeoBlockText } from './SeoBlockText';

const SeoBlockContent: FC = () => {
  const {
    isVisible,
    attachContentElement,
    maxHeight,
  } = useSeoBlockContext();

  return (
    <div
      ref={attachContentElement}
      className={classNames(
        seoBlockContentCss.seoBlockContent,
        { [seoBlockContentCss.seoBlockContent_visible]: isVisible },
      )}
      style={{
        maxHeight: isVisible ? maxHeight : undefined,
      }}
    >
      <SeoBlockText />
      <SeoBlockLinkList />
      <SeoBlockCityList />
    </div>
  );
};

export { SeoBlockContent };
